import request from '@/utils/requestLogin'
import store from '@/store'

const helper = {
  sessionStorageValue(name, defaultValue = null) {
    return sessionStorage.getItem(name) &&
      sessionStorage.getItem(name) !== 'undefined'
      ? JSON.parse(sessionStorage.getItem(name))
      : defaultValue
  },
}
const state = {
  access_token: helper.sessionStorageValue('access_token'),
  expires_in: helper.sessionStorageValue('expires_in', 30 * 60000),
  token_type: 'bearer',
  userID: helper.sessionStorageValue('userID'),
  statementForFree: helper.sessionStorageValue('statementForFree', false),
  username: helper.sessionStorageValue('username'),
  userPosition: helper.sessionStorageValue('userPosition'),
  userCompany: helper.sessionStorageValue('userCompany'),
  userRole: helper.sessionStorageValue('userRole', []),
  userAgreement: helper.sessionStorageValue('userAgreement', false),
  userSavAgreement: helper.sessionStorageValue('userSavAgreement', false),
  userAgreementsData: helper.sessionStorageValue('userAgreementsData', []),
  menuState: helper.sessionStorageValue('menuState'),
  userType: helper.sessionStorageValue('userType'),
  isPublic: helper.sessionStorageValue('isPublic'),
  userFactType: helper.sessionStorageValue('userFactType'),
  userFactSubType: helper.sessionStorageValue('userFactSubType'),
  isPersonDocumentsMandatory: helper.sessionStorageValue('is_person_documents_mandatory', false),
}
const getters = {
  getAccessToken: (state) => {
    return state.access_token
  },
  getExpiresIn: (state) => state.expires_in,
  getUsername: (state) => state.username,
  getUserPosition: (state) => state.userPosition,
  getUserCompany: (state) => state.userCompany,
  getUserType: (state) => state.userType,
  getIsPublic: (state) => state.isPublic,
  userID: (state) => state.userID,
  getStatementForFree: (state) => state.statementForFree,
  userAgreement: (state) => state.userAgreement,
  userSavAgreement: (state) => state.userSavAgreement,
  userAgreementsData: (state) => state.userAgreementsData,
  userRole: (state) => state.userRole,
  menuState: (state) => state.menuState,
  getUserFactType: (state) => state.userFactType,
  getUserFactSubType: (state) => state.userFactSubType,
  getIsPersonDocumentsMandatory: (state) => state.isPersonDocumentsMandatory,
}
const actions = {
  keepAlive({ commit, dispatch }, alive) {
    return request({
      url: '/keep-alive',
      method: 'post',
      data: {
        alive: alive,
      },
    })
      .then((resp) => {
        // resp
      })
      .catch(() => {})
  },
  localLogin({ commit, dispatch }, { username, password }) {
    return request({
      url: '/user/login',
      method: 'post',
      data: {
        username,
        password,
      },
    }).then((resp) => {
      commit('SET_USER_PROFILE', resp.user_profile)
      commit('SET_USER_ROLE', resp.roles)
      commit('SET_MENU_STATE', resp.menuState)
      commit('SET_USER_AGREEMENT_DATA', resp.agreements)
      commit('SET_FILE_VALIDATIONS', {max_file_size:resp.max_file_size, file_types:resp.file_types})
      commit('SET_IS_PERSON_DOCUMENTS_MANDATORY', resp.is_person_documents_mandatory)
      resp.first_login && commit('SET_USER_SAV_AGREEMENT', false)
    })
  },
  ipasasLogin({ commit, dispatch }, { enc }) {
    return request({
      url: '/ipasas',
      method: 'post',
      data: {
        enc,
        lang: store.getters.getSystemLang
      },
    })
      .then((resp) => {
        commit('SET_USER_PROFILE', resp.user_profile)
        commit('SET_USER_ROLE', resp.roles)
        commit('SET_MENU_STATE', resp.menuState)
        commit('SET_USER_AGREEMENT_DATA', resp.agreements)
        commit('SET_USER_SAV_AGREEMENT', false)
        commit('SET_FILE_VALIDATIONS', {max_file_size:resp.max_file_size, file_types:resp.file_types})
        commit('SET_IS_PERSON_DOCUMENTS_MANDATORY', resp.is_person_documents_mandatory)
        dispatch('keepAlive', true)
      })
      .catch(() => {

      })
  },
  savitarnaLogin(
    { commit, dispatch },
    { user_profile, roles, agreements, first_login, menuState, max_file_size, file_types, is_person_documents_mandatory}
  ) {
    commit('SET_USER_PROFILE', user_profile)
    commit('SET_USER_ROLE', roles)
    commit('SET_MENU_STATE', menuState)
    first_login && commit('SET_USER_AGREEMENT_DATA', agreements)
    first_login && commit('SET_USER_SAV_AGREEMENT', false)
    commit('SET_FILE_VALIDATIONS', {max_file_size:max_file_size, file_types:file_types})
    commit('SET_IS_PERSON_DOCUMENTS_MANDATORY', is_person_documents_mandatory)
    dispatch('keepAlive', true)
  },
  logout({ commit, dispatch }) {
    dispatch('keepAlive', false)
  },
  userAgreement({ commit }, agreement) {
    commit('SET_USER_AGREEMENT', agreement)
  },
  userSavAgreement({ commit }, agreement) {
    commit('SET_USER_SAV_AGREEMENT', agreement)
  },
  setStatementForFree({ commit }, state) {
    commit('SET_STATEMENT_FOR_FREE', state)
  },
}
const mutations = {
  SET_STATEMENT_FOR_FREE(state, data) {
    state.statementForFree = data
    sessionStorage.setItem('statementForFree', JSON.stringify(data))
  },
  SET_ACCESS_TOKEN(state, token) {
    state.access_token = token
    sessionStorage.setItem('access_token', JSON.stringify(token))
  },
  SET_USER_PROFILE(state, payload) {
    state.access_token = payload.api_token
    sessionStorage.setItem('access_token', JSON.stringify(payload.api_token))
    let expires_in =
      (payload.logout_time > 0 ? payload.logout_time : 30) * 60000
    state.expires_in = expires_in
    sessionStorage.setItem('expires_in', JSON.stringify(expires_in))

    state.userID = payload.usr_id
    sessionStorage.setItem('userID', JSON.stringify(payload.usr_id))

    state.statementForFree = payload.statement_for_free
    sessionStorage.setItem('statementForFree', JSON.stringify(payload.statement_for_free))

    state.userCompany = payload.usr_company
    sessionStorage.setItem('userCompany', JSON.stringify(payload.usr_company))

    state.userPosition = payload.usr_position
    sessionStorage.setItem('userPosition', JSON.stringify(payload.usr_position))

    state.username = payload.usr_name + ' ' + payload.usr_surname
    sessionStorage.setItem(
      'username',
      JSON.stringify(payload.usr_name + ' ' + payload.usr_surname)
    )

    state.userFactType = payload.fact_type
    sessionStorage.setItem('userFactType', JSON.stringify(payload.fact_type))

    state.userFactSubType = payload.fact_sub_type
    sessionStorage.setItem('userFactSubType', JSON.stringify(payload.fact_sub_type))

    state.userType = payload.usr_type
    sessionStorage.setItem('userType', JSON.stringify(payload.usr_type))

    state.isPublic = !!payload.is_public
    sessionStorage.setItem('isPublic', JSON.stringify(!!payload.is_public))
  },
  SET_USER_ROLE(state, payload) {
    state.userRole = payload
  },
  SET_USER_AGREEMENT(state, payload) {
    state.userAgreement = payload
    sessionStorage.setItem('userAgreement', JSON.stringify(payload))
  },
  SET_USER_SAV_AGREEMENT(state, payload) {
    state.userSavAgreement = payload
    sessionStorage.setItem('userSavAgreement', JSON.stringify(payload))
  },
  SET_USER_AGREEMENT_DATA(state, payload) {
    state.userAgreementsData = payload
    sessionStorage.setItem('userAgreementsData', JSON.stringify(payload))
    state.userAgreement = payload.length == 0
    sessionStorage.setItem('userAgreement', JSON.stringify(payload.length == 0))
  },
  SET_MENU_STATE(state, payload) {
    state.menuState = payload
    sessionStorage.setItem('menuState', JSON.stringify(payload))
  },
  SET_FILE_VALIDATIONS(state, payload) {
    state.fileValidations = payload
    sessionStorage.setItem('max_file_size', JSON.stringify(payload.max_file_size))
    sessionStorage.setItem('file_types', JSON.stringify(payload.file_types))
  },
  SET_IS_PERSON_DOCUMENTS_MANDATORY(state, payload) {
    state.isPersonDocumentsMandatory = payload
    sessionStorage.setItem('is_person_documents_mandatory', JSON.stringify(payload))
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
